export enum ChatStatuses {
  closed,
  opened,
}
